module.exports = __webpack_public_path__ + "img/face5.d2417284.jpg";